module.exports = __webpack_public_path__ + "img/ATRC Platform - Website TCs-05.fb6b6825.png";